import script from "./RecentMapCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RecentMapCard.vue?vue&type=script&setup=true&lang=js"

import "./RecentMapCard.vue?vue&type=style&index=0&id=29cdf2ce&lang=scss"

const __exports__ = script;

export default __exports__